import ValueObject from './ValueObject';

export default class MetroId extends ValueObject {
  equals(other) {
    if (!(other instanceof MetroId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new MetroId(json);
  }
}
